<template>
  <div v-if="showUnlinkCustomerPrompt || showCustomerUnlinkedModal">
    <confirmation-prompt
      id="unlink-customer"
      :show="showUnlinkCustomerPrompt"
      :title="i18n.t('/CustomerUnlink/ConfirmCustomerUnlinkTitle')"
      :info-text="i18n.t('/CustomerUnlink/ConfirmCustomerUnlinkText')"
      :disabled="isLoading"
      @confirm="unlinkCustomer"
      @close="showUnlinkCustomerPrompt = false"
    >
      <loader v-if="isLoading" />
    </confirmation-prompt>
    <modal
      v-if="showCustomerUnlinkedModal"
      :title="i18n.t('/CustomerUnlink/CustomerUnlinkSuccessfulTitle')"
      @close="showCustomerUnlinkedModal = false"
    >
      {{ i18n.t('/CustomerUnlink/CustomerUnlinkSuccessfulText') }}
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import { EventBus } from '@/plugins/event-bus'
import { mapGetters } from 'vuex'
import CustomersApi from '@/api/server/Customers'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import { pageTypes } from '@/helpers/pageTypeConstants'

export default {
  components: {
    Modal,
    ConfirmationPrompt,
    Loader,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: pageTypes.QUOTE,
      validator(value) {
        return Object.values(pageTypes).includes(value)
      },
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showUnlinkCustomerPrompt: false,
      showCustomerUnlinkedModal: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      customer: 'quote/customer',
      purchaseCustomer: 'purchaseOrder/customer',
      dealerSettings: 'user/dealerSettings',
      company: 'quote/customerCompany',
      purchaseCompany: 'purchaseOrder/customerCompany',
    }),
    customerCompanyMagicNumber() {
      if (this.pageType === pageTypes.PURCHASE_ORDER) {
        return this.purchaseCustomer?.CustomerCompanyMagicNumber
      }
      if (this.pageType === pageTypes.QUOTE) {
        return this.customer?.CustomerCompanyMagicNumber
      }
      return ''
    },
    customerMagicNumber() {
      if (this.pageType === pageTypes.PURCHASE_ORDER) {
        return this.purchaseCustomer?.CustomerMagicNumber
      }
      if (this.pageType === pageTypes.QUOTE) {
        return this.customer?.CustomerMagicNumber
      }
      return ''
    },
    companyMagicNumber() {
      if (this.pageType === pageTypes.PURCHASE_ORDER) {
        return this.purchaseCompany?.CustomerCompanyMagicNumber
      }
      if (this.pageType === pageTypes.QUOTE) {
        return this.company?.CustomerCompanyMagicNumber
      }
      return ''
    },
    getNameSpace() {
      if (this.pageType === pageTypes.PURCHASE_ORDER) {
        return 'purchaseOrder'
      }
      if (this.pageType === pageTypes.QUOTE) {
        return 'quote'
      }
      if (this.pageType === pageTypes.CHANGE_ORDER) {
        return 'changeOrder'
      }

      return 'quote'
    },
  },
  mounted() {
    EventBus.$on(`${this.getNameSpace}/companyUpdated`, this.checkCustomerCompanyMagicNumber)
    EventBus.$on(`${this.getNameSpace}/customerUpdated`, this.checkCustomerCompanyMagicNumber)
  },
  unmounted() {
    EventBus.$off(`${this.getNameSpace}/companyUpdated`, this.checkCustomerCompanyMagicNumber)
    EventBus.$off(`${this.getNameSpace}/customerUpdated`, this.checkCustomerCompanyMagicNumber)
  },
  methods: {
    checkCustomerCompanyMagicNumber() {
      if (
        this.dealerSettings.autolineKeyloopEnabled &&
        !!this.customerCompanyMagicNumber &&
        !!this.companyMagicNumber &&
        this.customerCompanyMagicNumber != this.companyMagicNumber
      ) {
        this.showUnlinkCustomerPrompt = true
      }
    },
    async unlinkCustomer() {
      this.isLoading = true
      await CustomersApi.postCustomerCompanyRelation({
        customerMagicNumber: this.customerMagicNumber,
        customerCompanyMagicNumber: this.customerCompanyMagicNumber,
        linkCustomer: false,
      })
        .then(() => {
          this.showUnlinkCustomerPrompt = false
          this.showCustomerUnlinkedModal = true
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
